/* Compare: inject the toggle into theme product cards.

   The Athora card is a web component (hdt-card-product) rendered by the
   theme, and a Custom Liquid block inside it may not expose `product` under
   that name. Reading the handle from the card's own product link avoids
   guessing the variable, and works on grids that filter or paginate in place.

   Only cards for products in croCompareData get a button, so oils and reeds
   are left alone. */
(function () {
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    return m ? m[1] : '';
  }

  function add(card) {
    if (card.querySelector('[data-compare]')) return;
    var h = handleOf(card);
    if (!h || !(window.croCompareData || {})[h]) return;
    var box = card.querySelector('.hdt-card-product__content') || card;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cro-cmp__btn';
    b.setAttribute('data-compare', h);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<span class="cro-cmp__box" aria-hidden="true"></span><span>Compare</span>';
    var desc = box.querySelector('.aroma-card-short-desc');
    if (desc) { box.insertBefore(b, desc); } else { box.appendChild(b); }
  }

  function scan() {
    var cards = document.querySelectorAll('hdt-card-product, .hdt-card-product');
    for (var i = 0; i < cards.length; i++) add(cards[i]);
    document.dispatchEvent(new CustomEvent('compare:changed'));
  }

  function init() {
    scan();
    var grid = document.querySelector('.hdt-collection-products, main') || document.body;
    new MutationObserver(function () { setTimeout(scan, 80); })
      .observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
